/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedBillboardAd_itemSearch$ref = any;
export type SbSharedBillboardAd_itemSearch = {
    readonly displayUriRef: string | null;
    readonly " $refType": SbSharedBillboardAd_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedBillboardAd_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'cf87c77b8210f4aef685eb02e7c9deca';
export default node;
